@if (
  vendorForm &&
  streetAddressForm &&
  mailingAddressForm &&
  remitToAddressForm &&
  localizationInfo &&
  VendorId &&
  ClientCompanyVendorMap &&
  Vendor
) {
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <form [formGroup]="vendorForm">
          <div><h3>Company Information</h3></div>
          @if (vendorForm.controls['country'].value === 'US') {
            <div class="row align-items-center row-padding">
              <div class="col-md-3 form-group">
                <label
                  >Tax Structure<span class="required-field-asterisk"
                    >*</span
                  ></label
                >
                <app-select-dropdown
                  [control]="vendorForm.controls['companyType']"
                  [options]="usTaxStructures"
                  [dropdownId]="'us-tax-structure-dropdown'"
                  (ngModelChange)="companyTypeChanged($event)"
                ></app-select-dropdown>
              </div>
              @if (displayLLCType()) {
                <div class="col-md-3 form-group">
                  <label
                    >LLC Type<span class="required-field-asterisk"
                      >*</span
                    ></label
                  >
                  <app-select-dropdown
                    [control]="vendorForm.controls['llcType']"
                    [options]="llcTypes"
                    [placeholder]="'Select LLC Type...'"
                    [dropdownId]="'llc-type-dropdown'"
                  ></app-select-dropdown>
                </div>
              }
              <div class="col-md-3 form-group">
                <label
                  >Company {{ localizationInfo.taxId('ein').label }} (Tax ID #)
                  @if (requireEIN()) {
                    <span class="required-field-asterisk">*</span>
                  }
                </label>
                <span (click)="handleTaxIdOrLegalNameClick($event)"
                  ><input
                    [ngClass]="{
                      'pe-none':
                        Vendor.hasSignedAnyVendorAgreement &&
                        Vendor.hasMultipleClients &&
                        !hasEditPermissions()
                    }"
                    class="form-control"
                    type="text"
                    placeholder="__-_______"
                    [inputMask]="einMask"
                    (ngModelChange)="onEinSsnChange()"
                    formControlName="ein"
                /></span>
              </div>
              @if (displaySSN()) {
                <div class="col-md-3">
                  @if (
                    fullSSNPermissions.has(
                      LoggedInUser.UserAccountRole?.role || ''
                    ) || maskedSSN
                  ) {
                    <label
                      >{{ localizationInfo.taxId('ssn').label }} (Tax ID #)
                      @if (requireSSN()) {
                        <span class="required-field-asterisk">*</span>
                      }
                    </label>
                  }
                  @if (maskedSSN) {
                    <label class="fw-normal">{{ maskedSSN }}</label>
                  }
                  @if (
                    fullSSNPermissions.has(
                      LoggedInUser.UserAccountRole?.role || ''
                    )
                  ) {
                    <span (click)="handleTaxIdOrLegalNameClick($event)"
                      ><input
                        [ngClass]="{
                          'pe-none':
                            Vendor.hasSignedAnyVendorAgreement &&
                            Vendor.hasMultipleClients &&
                            !hasEditPermissions()
                        }"
                        class="form-control"
                        type="text"
                        placeholder="___-__-____"
                        [inputMask]="ssnMask"
                        (ngModelChange)="onEinSsnChange()"
                        formControlName="ssn"
                    /></span>
                  }
                  @if (!hasSSNAccess) {
                    <label class="fw-normal">SSN: ***_**_****</label>
                  }
                  @if (
                    !fullSSNPermissions.has(
                      $safeNavigationMigration(
                        LoggedInUser.UserAccountRole?.role
                      )!
                    ) &&
                    Vendor.hasSSN &&
                    hasSSNAccess &&
                    !maskedSSN &&
                    !fullSSN
                  ) {
                    <button class="btn btn-primary" (click)="viewSSN()">
                      View SSN
                    </button>
                  }
                </div>
              }
            </div>
          }
          @if (
            vendorForm.controls['country'].value === 'US' &&
            vendorForm.controls['companyType'].value === 'Sole Proprietorship'
          ) {
            <div class="row row-padding">
              <div class="col">
                <label class="error-red"
                  >Enter your individual name as shown on your Form 1040 on line
                  1. Enter your business, trade, or "doing business as" (DBA)
                  name on line 2.</label
                >
              </div>
            </div>
          }
          <div class="row row-padding">
            <div
              class="col-md-3 form-group d-flex flex-column justify-content-end"
            >
              <label
                >{{ localizationInfo.legalName.label
                }}<span class="required-field-asterisk">*</span></label
              >
              <span (click)="handleTaxIdOrLegalNameClick($event)"
                ><input
                  [ngClass]="{
                    'pe-none':
                      Vendor.hasSignedAnyVendorAgreement &&
                      Vendor.hasMultipleClients &&
                      !hasEditPermissions()
                  }"
                  class="form-control"
                  type="text"
                  formControlName="legalName"
              /></span>
            </div>
            <div
              class="col-md-3 form-group d-flex flex-column justify-content-end"
            >
              <label>{{ localizationInfo.registrationDba.label }}</label>
              <input
                class="form-control"
                type="text"
                formControlName="dba"
                (blur)="validateDba()"
              />
            </div>
            <div
              class="col-md-3 form-group d-flex flex-column justify-content-end"
            >
              <label
                >Office Phone<span class="required-field-asterisk"
                  >*</span
                ></label
              >
              <input
                class="form-control"
                type="text"
                placeholder="(___) ___-____"
                [inputMask]="phoneMask"
                formControlName="phone"
              />
            </div>
            <div
              class="col-md-3 form-group d-flex flex-column justify-content-end"
            >
              <label>Extension</label>
              <input
                type="text"
                class="form-control"
                [inputMask]="phoneExtensionMask"
                formControlName="phoneExt"
                max="6"
              />
            </div>
          </div>
          @if (vendorForm.controls['country'].value === 'CA') {
            <div class="row row-padding">
              <div class="col-md-3 form-group">
                <label
                  >Tax Structure<span class="required-field-asterisk"
                    >*</span
                  ></label
                >
                <app-select-dropdown
                  [control]="vendorForm.controls['companyType']"
                  [options]="caTaxStructures"
                  [placeholder]="'Select Tax Structure...'"
                  [dropdownId]="'ca-tax-structure-dropdown'"
                ></app-select-dropdown>
              </div>
              <div class="col-md-3 form-group">
                <label
                  >{{ localizationInfo.taxId('gst-hst').label }} (Tax ID #)
                  @if (!vendorForm.controls['usesSIN'].value) {
                    <span class="required-field-asterisk">*</span>
                  }
                </label>
                <span (click)="handleTaxIdOrLegalNameClick($event)"
                  ><input
                    [ngClass]="{
                      'pe-none':
                        Vendor.hasSignedAnyVendorAgreement &&
                        Vendor.hasMultipleClients &&
                        !hasEditPermissions()
                    }"
                    class="form-control"
                    type="text"
                    placeholder="_________"
                    [inputMask]="gstHstMask"
                    formControlName="bsn"
                /></span>
              </div>
              <div class="col-md-3">
                <label class="form-check-label w-100">Uses SIN</label>
                <input
                  class="form-check-input p-2 mt-0"
                  type="checkbox"
                  (change)="sinChanged()"
                  formControlName="usesSIN"
                />
              </div>
            </div>
          }
          <div class="row row-padding">
            <div
              class="col-md-4 form-group d-flex flex-column justify-content-end"
            >
              <label
                >Number of Employees<span class="required-field-asterisk"
                  >*</span
                ></label
              >
              <app-select-dropdown
                [control]="vendorForm.controls['qtyEmployees']"
                [options]="employeeQuantityOptions"
                [placeholder]="''"
                [dropdownId]="'employee-quantity-dropdown'"
              ></app-select-dropdown>
            </div>
            <div
              class="col-md-4 form-group d-flex flex-column justify-content-end"
            >
              <label
                >Do you employ Sub-Contractors?<span
                  class="required-field-asterisk"
                  >*</span
                ></label
              >
              <app-select-dropdown
                [control]="vendorForm.controls['employsSubContractors']"
                [options]="yesNoOptions"
                [placeholder]="'Select Yes or No...'"
                [dropdownId]="'employs-sub-contractors-dropdown'"
              ></app-select-dropdown>
            </div>
            <div
              class="col-md-4 form-group d-flex flex-column justify-content-end"
            >
              <label
                >Does your business provide after hours emergency services?<span
                  class="required-field-asterisk"
                  >*</span
                ></label
              >
              <app-select-dropdown
                [control]="vendorForm.controls['allowAfterHoursService']"
                [options]="yesNoOptions"
                [placeholder]="'Select Yes or No...'"
                [dropdownId]="'after-hours-emergency-services-dropdown'"
              ></app-select-dropdown>
            </div>
          </div>
          @if (vendorForm.controls['allowAfterHoursService'].value) {
            <div class="row row-padding">
              <div
                class="col-md-3 form-group d-flex flex-column justify-content-end"
              >
                <label
                  >After hours phone<span class="required-field-asterisk"
                    >*</span
                  ></label
                >
                <input
                  class="form-control"
                  type="text"
                  placeholder="(___) ___-____"
                  [inputMask]="phoneMask"
                  formControlName="afterHoursPhone"
                />
              </div>
              <div
                class="col-md-3 form-group d-flex flex-column justify-content-end"
              >
                <label>After hours phone Extension</label>
                <input
                  class="form-control"
                  type="text"
                  [inputMask]="phoneExtensionMask"
                  formControlName="afterHoursPhoneExt"
                />
              </div>
            </div>
          }
          <div class="row row-padding">
            @if (
              vendorForm.controls['country'].value === 'US' &&
              Vendor.hasFullPackageClient
            ) {
              <div
                class="col-md-4 form-group d-flex flex-column justify-content-end"
              >
                <label
                  >Are you publicly traded?<span class="required-field-asterisk"
                    >*</span
                  ></label
                >
                <app-select-dropdown
                  [control]="vendorForm.controls['isPubliclyTraded']"
                  [options]="yesNoOptions"
                  [placeholder]="'Select Yes or No...'"
                  [dropdownId]="'publicly-traded-dropdown'"
                ></app-select-dropdown>
              </div>
            }
            <div
              class="col-md-4 form-group d-flex flex-column justify-content-end"
            >
              <label
                >Year Established<span class="required-field-asterisk"
                  >*</span
                ></label
              >
              <app-select-dropdown
                [control]="vendorForm.controls['yearEstablished']"
                [options]="yearArray"
                [placeholder]="''"
                [dropdownId]="'year-established-dropdown'"
              ></app-select-dropdown>
            </div>
            @if (vendorForm.controls['country'].value === 'US') {
              <div
                class="col-md-4 form-group d-flex flex-column justify-content-end"
              >
                <label>Small Business / Minority Owned</label>
                <!--Custom Tag Field Component Below-->
                <div class="dropdown" #tagfieldDropdown>
                  <div
                    (keydown)="preventInput($event)"
                    (click)="toggleTagfieldDropdown(); $event.stopPropagation()"
                    contenteditable="true"
                    id="tagfield-dropdown"
                    class="form-control tag-field dropdown-toggle-override"
                    [class.show]="tagfieldDropdownOpen"
                    aria-expanded="false"
                    role="button"
                    tabindex="0"
                  >
                    <span class="icon-container">
                      <i class="bi bi-chevron-down chevron-icon pull-right"></i>
                    </span>
                    @for (
                      item of selectedSmallBusinessOptionsFormArray.controls;
                      track item
                    ) {
                      <span
                        class="badge bg-primary badge-margin"
                        contenteditable="false"
                        tabindex="-1"
                      >
                        {{ item.value.type }}
                        <i
                          class="bi bi-x-lg cursor-select"
                          (click)="
                            deselectSmallBusinessOption(item.value.type!)
                          "
                        ></i>
                      </span>
                    }
                  </div>
                  <ul
                    class="dropdown-menu dropdown-menu-width"
                    [class.show]="tagfieldDropdownOpen"
                    aria-labelledby="tagfield-dropdown"
                    (click)="$event.stopPropagation()"
                  >
                    @for (
                      item of smallBusinessOptions | keyvalue: preserveMapOrder;
                      track item
                    ) {
                      <li>
                        @if (!item.value) {
                          <button
                            type="button"
                            class="dropdown-item cursor-select"
                            (click)="
                              selectSmallBusinessOption([item.key, item.value]);
                              $event.stopPropagation()
                            "
                          >
                            {{ item.key }}
                          </button>
                        }
                      </li>
                    }
                  </ul>
                </div>
                <!--Custom Tag Field Component Above-->
              </div>
            }
          </div>
          @if (isAnyCompanyOffices()) {
            <div class="row row-padding">
              <div class="col-12 form-group">
                <label>Client Offices</label>
                <app-client-vendor-office-selection
                  [VendorForm]="vendorForm"
                ></app-client-vendor-office-selection>
              </div>
            </div>
          }
          @if (OperatingStatesForm) {
            <div class="row row-padding">
              <div class="col-12 form-group">
                <label
                  >Operating {{ localizationInfo.territoryPlural.label }}</label
                >
                <p class="form-text mt-0 mb-2">
                  {{ localizationInfo.territoryPlural.label }} this vendor
                  performs work in. Those marked
                  <i class="bi bi-shield-check"></i> are where one of their
                  clients operates.
                </p>
                <app-vendor-operating-states
                  [VendorId]="VendorId"
                  [country]="vendorForm.controls['country'].value"
                  [localizationInfo]="localizationInfo"
                  [OperatingStatesForm]="OperatingStatesForm"
                ></app-vendor-operating-states>
              </div>
            </div>
          }
          @if (
            vendorForm.controls['country'].value === 'US' &&
            vendorForm.controls['isPubliclyTraded'].value === true
          ) {
            <div class="row">
              <div class="col-md-3 form-group">
                <label
                  >Stock Exchange<span class="required-field-asterisk"
                    >*</span
                  ></label
                >
                <app-select-dropdown
                  [control]="vendorForm.controls['stockExchange']"
                  [options]="stockExchanges"
                  [placeholder]="'Select Stock Exchange...'"
                  [dropdownId]="'stock-exchange-dropdown'"
                ></app-select-dropdown>
              </div>
              <div class="col-md-3 form-group">
                <label
                  >Stock Symbol<span class="required-field-asterisk"
                    >*</span
                  ></label
                >
                <input
                  class="form-control"
                  type="text"
                  formControlName="stockSymbol"
                />
              </div>
            </div>
          }
        </form>
        <app-vendor-address-edit
          [VendorId]="VendorId"
          [streetAddressForm]="streetAddressForm"
          [mailingAddressForm]="mailingAddressForm"
          [remitToAddressForm]="remitToAddressForm"
          [streetAddress]="streetAddress"
          [mailingAddress]="mailingAddress"
          [remitToAddress]="remitToAddress"
          [country]="vendorForm.controls['country'].value"
          [localizationInfo]="localizationInfo"
        ></app-vendor-address-edit>
      </div>
    </div>
  </div>
}
